import { render, staticRenderFns } from "./PanierDrawer.vue?vue&type=template&id=5879a9a8"
import script from "./PanierDrawer.vue?vue&type=script&lang=js"
export * from "./PanierDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports